import React from "react";
// import "./CanadaMasterfile.css";
import "../../GlobalCss/SPF/CanadaMasterfile.css";
import { useState, useEffect } from "react";
import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
import { DeleteOutlined, UploadOutlined, ReloadOutlined, LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Layout, Modal, message, Spin, Image, Upload } from "antd";
import { BaseUrl, JsonConfig, FormConfig, UserName } from "../../Repository/BaseRepository";
import CanadaMfTable from "../../Components/CanadaPayroll/CanadaMfTable";
import axios from "axios";
import { ErrorMessage, routes, SuccessMessage } from "../../Utils/Utils";
import { Redirect, Link } from "react-router-dom";
import Cookies from "js-cookie";
import { getCanadaPayrollData } from "../../Repository/CanadaPayrollRepository";
const { Header, Content } = Layout;

const CanadaMasterfile = () => {
    const [hrSourceFile, setHrSourceFile] = useState([]);
    const [spin, setSpin] = useState(false)
    const [hrUploader, setHrUploader] = useState("");
    const [tableLoader, setTableLoader] = useState(false)
    const [griddata, setGriddata] = useState([])
    const [fromDate, setFromDate] = useState()
    const [toDate, setTodate] = useState()
    const tenantName = Cookies.get("tenant_name");
    useEffect(() => {
        // callAccoutsCube();
    }, [])
    const callAccoutsCube = async () => {
        try {
            setTableLoader(true)
            const res = await getCanadaPayrollData();
            if (res !== null && res.length > 0) {
                setGriddata(res);
            }
            setTableLoader(false)
        }
        catch {
            ErrorMessage("Cannot able to get data, please try again")
        }
    }

    return (<>
        <Layout style={{ backgroundColor: "white", height: "100vh", display: "flex", overflow: "hidden" }} >
            <SideNavBar />
            <Layout style={{ backgroundColor: "white", overflow: "hidden" }}>
                <Header className="preview-header-class"><Navbar /></Header>
                <Content style={{ overflow: 'auto', height: "100%", marginLeft: 20 }}>
                <h1 className="canada-header">Canada Payroll</h1>
                    <div className="otherpage-buttons">
                    <Link to={`/${tenantName}/canadaautocrawl`}><Button  className="page-button">AutoCrawl</Button></Link>
                        <Link to={`/${tenantName}/canadapayroll`}><Button className="page-button">Selected Crawling</Button></Link>
                        <Button className="currentpage-button">Consolidated Data</Button>
                        <Link to={`/${tenantName}/canadamasterfile`}><Button className="page-button">Masterfile</Button></Link>
                       
                    </div>
                    <div className="ten99-row1">
                        {/* <div className="inputfile-upload">
                            <Upload
                                className="hr-upload-file"
                                name="file"
                                customRequest={handleUpload}
                                itemRender={itemRender}
                                fileList={hrSourceFile}
                                accept=".xls,.xlsx"
                                onRemove={() => setHrSourceFile([])}
                                style={{ border: "1px solid #3B52DF", borderRadius: 10, borderStyle: "dashed" }}
                            >
                                <div className='hr-content-file'>
                                    <span className="hrfile-name">Upload File</span>
                                    {spin ? <Spin indicator={<LoadingOutlined className="upload-spinner" style={{ fontSize: 16, marginLeft: 7, color: "#3B52DF" }} spin />} />

                                        // <Spin size="medium" style={{ marginLeft: '5px', marginTop:"3px" }} /> 
                                        : <Image src="./Images/uploadimg (2).png"
                                            style={{
                                                border: "none",
                                                width: 19,
                                                height: 17,
                                            }}
                                            showPreviewIcon={false}
                                            preview={false} />}
                                </div>
                            </Upload>
                            {hrUploader.length > 0 ? <div style={{ width: 'fit-content', wordBreak: 'break-all', marginBottom: 2, color: "#3B52DF" }}>{hrUploader}</div> : null}
                        </div> */}
                        {/* <Button className="add-row-1099" onClick={() => AddNewRecord()}>Add New Record<PlusOutlined /></Button> */}
                    </div>
                    <div className="canada-row3">
                        <CanadaMfTable tableLoader={tableLoader} setTableLoader={setTableLoader} griddata={griddata} setGriddata={setGriddata} 
                        fromDate={fromDate} setFromDate={setFromDate} toDate={toDate} setTodate={setTodate}/>
                    </div>
                </Content>
            </Layout>
        </Layout>
    </>)
}
export default CanadaMasterfile;